export const GET_DEVELOPER_REQUESTS = "GET_DEVELOPER_REQUESTS";
export const GET_DEVELOPER_REQUESTS_SUCCESS = "GET_DEVELOPER_REQUESTS_SUCCESS";
export const GET_DEVELOPER_REQUESTS_FAILURE = "GET_DEVELOPER_REQUESTS_FAILURE";

export const GET_SINGLE_DEVELOPER_REQUEST = "GET_SINGLE_DEVELOPER_REQUEST";
export const GET_SINGLE_DEVELOPER_REQUEST_SUCCESS =
  "GET_SINGLE_DEVELOPER_REQUEST_SUCCESS";
export const GET_SINGLE_DEVELOPER_REQUEST_FAILURE =
  "GET_SINGLE_DEVELOPER_REQUEST_FAILURE";

export const DELETE_DEVELOPER_REQUEST = "DELETE_DEVELOPER_REQUEST";
export const DELETE_DEVELOPER_REQUEST_SUCCESS =
  "DELETE_DEVELOPER_REQUEST_SUCCESS";
export const DELETE_DEVELOPER_REQUEST_FAILURE =
  "DELETE_DEVELOPER_REQUEST_FAILURE";
